// @ts-nocheck
import { makeStyles } from '@material-ui/core';
import login_bg from 'assets/img/login_bg.png';

export const useClientStyles = makeStyles(() => ({
  root: {
    backgroundImage: `url(${login_bg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  stack: {
    minHeight: '100vh',
  },
  card: {
    maxWidth: 450,
  },
  button: {
    width: '100%!important',
    padding: '15px 20px!important',
    marginTop: '15px!important',
    fontFamily: 'Barlow Semi Condensed, sans-serif!important',
    fontSize: '14px!important',
    fontWeight: '600!important',
    lineHeight: '1.2!important',
  },
  link: {
    color: '#fff!important',
    textDecoration: 'underline!important',
  },
  pdfCard: {
    backgroundColor: '#F3F6FB',
    width: '100%',
  },
  pdfText: {
    color: '#6A737B',
  },
  darkText: {
    color: '#212529',
  },
  signCard: {
    background: '#eee',
    maxWidth: '100%',
  },
  signWrap: {
    border: '1px dashed #ccc',
    cursor: 'pointer',
  },
  actionCard: {
    background: '#fff',
    maxWidth: '92%',
    borderRadius: '16px',
  },
}));
